module.exports = __webpack_public_path__ + "img/15.24f4d987.svg";